import { useLanguage } from "@/lib/LanguageContext";
import Logo3D from "@/components/Logo3D";

export default function Nav() {
    const { toggleLang, t } = useLanguage();
    return (
        <header className="ps-nav" data-testid="nav">
            <div className="ps-container ps-nav-inner">
                <a href="#hero" className="ps-nav-logo" data-testid="nav-logo">
                    <Logo3D size={30} />
                    <span>Pernalete<em>°</em> Studio</span>
                </a>
                <nav className="ps-nav-links" data-testid="nav-links">
                    <a href="#about" data-testid="nav-about">{t.nav.about}</a>
                    <a href="#services" data-testid="nav-services">{t.nav.services}</a>
                    <a href="#projects" data-testid="nav-projects">{t.nav.projects}</a>
                    <a href="#pricing" data-testid="nav-pricing">{t.nav.pricing}</a>
                    <a href="#faq" data-testid="nav-faq">{t.nav.faq}</a>
                    <button
                        type="button"
                        className="ps-lang-toggle ps-mono"
                        onClick={toggleLang}
                        data-testid="nav-lang-toggle"
                        aria-label={`${t.nav.langToggle} — cambiar idioma / switch language`}
                    >
                        {t.nav.langToggle}
                    </button>
                    <a href="#contact" className="ps-nav-cta" data-testid="nav-contact">{t.nav.contact}</a>
                </nav>
            </div>
        </header>
    );
}
